import { render, staticRenderFns } from "./EditServiceSideBarTabsSubDetail.vue?vue&type=template&id=3edb1f9c&"
import script from "./EditServiceSideBarTabsSubDetail.vue?vue&type=script&lang=js&"
export * from "./EditServiceSideBarTabsSubDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports